// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.footer {
  width: 100%;
  display: flex;
  padding: 20px 0;
  z-index: 100;
  position: relative;
  border-top: 1px solid #080808;
}

.footer__wrapper {
  margin: 0 auto;
  max-width: 1280px;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-around;
  padding: 0 40px;
}

.footer__block {
  width: 100%;
  display: flex;
  gap: 13px;
}

.footer__title {
  font-family: Oswald-light, sans-serif;
  font-weight: 300;
  font-size: 22px;
  font-weight: 400;
  line-height: 25px;
  margin: 0;
  padding: 0;
  padding-left: 20px;
  color: #073042;
}

.footer__copyright {
  font-family: Oswald-light, sans-serif;
  font-weight: 300;
  font-size: 20px;
  line-height: 25px;
  margin: 0;
  padding: 0;
  color: #073042;
}

.footer__block-info {
  display: flex;
  align-items: center;
  gap: 15px;
}

.footer__block-info img {
  margin-top: 15px;
}

.footer__btn {
  font-family: Oswald-light, sans-serif;
  font-weight: 300;
  font-size: 14px;
  letter-spacing: 1px;
  text-align: center;
  box-sizing: content-box;
  margin: 0;
  padding: 0;
  border: 0;
  color: #073042 !important;
  text-decoration: none;
  padding-right: 20px;
  background-color: #fcfdfd;
}

@media screen and (max-width: 610px) {
  .footer {
    padding: 10px 0;
  }
  .footer__wrapper {
    flex-direction: column;
    gap: 10px;
  }
  .footer__block {
    justify-content: center;
    gap: 10px;
  }

  .footer__title {
    padding: 0;
    font-size: 16px;
  }

  .footer__copyright {
    font-size: 14px;
  }

  .footer__btn {
    padding: 0;
    font-size: 10px;
  }
  .footer__block-info {
    gap: 10px;
  }

  .footer__block-info img {
    margin: 0;
    width: 50px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/Footer/Footer.css"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,aAAa;EACb,eAAe;EACf,YAAY;EACZ,kBAAkB;EAClB,6BAA6B;AAC/B;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,6BAA6B;EAC7B,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,SAAS;AACX;;AAEA;EACE,qCAAqC;EACrC,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,SAAS;EACT,UAAU;EACV,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,qCAAqC;EACrC,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,SAAS;EACT,UAAU;EACV,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,qCAAqC;EACrC,gBAAgB;EAChB,eAAe;EACf,mBAAmB;EACnB,kBAAkB;EAClB,uBAAuB;EACvB,SAAS;EACT,UAAU;EACV,SAAS;EACT,yBAAyB;EACzB,qBAAqB;EACrB,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE;IACE,eAAe;EACjB;EACA;IACE,sBAAsB;IACtB,SAAS;EACX;EACA;IACE,uBAAuB;IACvB,SAAS;EACX;;EAEA;IACE,UAAU;IACV,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,UAAU;IACV,eAAe;EACjB;EACA;IACE,SAAS;EACX;;EAEA;IACE,SAAS;IACT,WAAW;EACb;AACF","sourcesContent":[".footer {\n  width: 100%;\n  display: flex;\n  padding: 20px 0;\n  z-index: 100;\n  position: relative;\n  border-top: 1px solid #080808;\n}\n\n.footer__wrapper {\n  margin: 0 auto;\n  max-width: 1280px;\n  width: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: space-around;\n  padding: 0 40px;\n}\n\n.footer__block {\n  width: 100%;\n  display: flex;\n  gap: 13px;\n}\n\n.footer__title {\n  font-family: Oswald-light, sans-serif;\n  font-weight: 300;\n  font-size: 22px;\n  font-weight: 400;\n  line-height: 25px;\n  margin: 0;\n  padding: 0;\n  padding-left: 20px;\n  color: #073042;\n}\n\n.footer__copyright {\n  font-family: Oswald-light, sans-serif;\n  font-weight: 300;\n  font-size: 20px;\n  line-height: 25px;\n  margin: 0;\n  padding: 0;\n  color: #073042;\n}\n\n.footer__block-info {\n  display: flex;\n  align-items: center;\n  gap: 15px;\n}\n\n.footer__block-info img {\n  margin-top: 15px;\n}\n\n.footer__btn {\n  font-family: Oswald-light, sans-serif;\n  font-weight: 300;\n  font-size: 14px;\n  letter-spacing: 1px;\n  text-align: center;\n  box-sizing: content-box;\n  margin: 0;\n  padding: 0;\n  border: 0;\n  color: #073042 !important;\n  text-decoration: none;\n  padding-right: 20px;\n  background-color: #fcfdfd;\n}\n\n@media screen and (max-width: 610px) {\n  .footer {\n    padding: 10px 0;\n  }\n  .footer__wrapper {\n    flex-direction: column;\n    gap: 10px;\n  }\n  .footer__block {\n    justify-content: center;\n    gap: 10px;\n  }\n\n  .footer__title {\n    padding: 0;\n    font-size: 16px;\n  }\n\n  .footer__copyright {\n    font-size: 14px;\n  }\n\n  .footer__btn {\n    padding: 0;\n    font-size: 10px;\n  }\n  .footer__block-info {\n    gap: 10px;\n  }\n\n  .footer__block-info img {\n    margin: 0;\n    width: 50px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
